/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import Backbone from 'app/common/vendor/backbone';
import { ChannelSwitcherPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';
import { getMe } from 'app/gamma/src/selectors/members';

import { MemberModel } from 'app/gamma/src/types';
import HeaderButton from './button';

const ChannelSwitcherPopoverPromise = import(/* webpackChunkName: "channel-switcher-popover" */ 'app/gamma/src/components/popovers/channel-switcher');
const ChannelSwitcherPopover = lazy(() => ChannelSwitcherPopoverPromise);

interface ChannelSwitcherButtonProps {
  member: MemberModel | undefined;
  hostname: string;
  isActive: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

// Show channel picker if user is allowed to view multiple channels
// OR if we're not on production (to make development easier)
const shouldShowChannelPicker = (
  member: MemberModel | undefined,
  hostname: string,
): boolean => {
  if (hostname !== 'trello.com') {
    return true;
  }

  return !!(member && member.channels && member.channels.allowed.length > 1);
};

export class ChannelSwitcherButton extends React.Component<
  ChannelSwitcherButtonProps
> {
  channelSwitcherButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { member, hostname, isActive, onClick } = this.props;
    const showButton = shouldShowChannelPicker(member, hostname);
    if (!showButton) {
      return null;
    }

    return (
      <>
        <HeaderButton
          icon={IconName.Gear}
          onClick={onClick}
          ref={this.channelSwitcherButtonRef}
          testId={HeaderTestIds.ChannelPickerButton}
        />
        {member &&
          showButton &&
          isActive && (
            <Suspense fallback={null}>
              <ChannelSwitcherPopover
                target={() => this.channelSwitcherButtonRef.current}
              />
            </Suspense>
          )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    member: getMe(state),
    isActive: isPopoverShown(state, ChannelSwitcherPopoverId),
    hostname: Backbone.history.location.hostname,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<object>) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      dispatch(showPopover({ name: ChannelSwitcherPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChannelSwitcherButton);
